import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { api } from './api'
import Button from './Button.jsx'

/**
 * Asking for a reset link.
 *
 * The answer is the same whether or not the address is known here, because the server answers the
 * same way — telling someone which addresses have accounts is telling them about a person who is
 * not in the room.
 */
export default function ForgotPassword({ onBack }) {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState(null)
  const [error, setError] = useState(null)

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)

    try {
      const result = await api.forgotPassword(email)
      setSent(result)
    } catch (failure) {
      setError(failure.message)
    } finally {
      setBusy(false)
    }
  }

  if (sent) {
    return (
      <section className="card card--center">
        <h2>{t('forgot.title')}</h2>
        {/* Said plainly when no mail can leave this server, rather than sending someone to an
            inbox that will stay empty. */}
        <p className={sent.canSend ? 'status status--good' : 'status status--bad'}>
          {t(sent.canSend ? 'forgot.sent' : 'forgot.cannotSend')}
        </p>
        <button type="button" className="link" onClick={onBack}>
          {t('forgot.back')}
        </button>
      </section>
    )
  }

  return (
    <section className="card card--center">
      <h2>{t('forgot.title')}</h2>
      <p className="muted">{t('forgot.help')}</p>

      <form onSubmit={submit}>
        <label className="field">
          {t('login.email')}
          <input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        {error && <p className="status status--bad">{error}</p>}

        <Button type="submit" className="button" disabled={!email} loading={busy}>
          {t('forgot.send')}
        </Button>
      </form>

      <button type="button" className="link" onClick={onBack}>
        {t('forgot.back')}
      </button>
    </section>
  )
}
